import { RenderFunc } from '../types/RenderFunc';

export const renderIsNeedApplyChangesInApprovedPlan: RenderFunc = item => {
  const { newValue, oldValue } = item;

  return {
    renderedOldValue:
      typeof oldValue === 'boolean' ? (oldValue && 'Да') || 'Нет' : (typeof oldValue === 'string' && oldValue) || '',
    renderedNewValue:
      typeof newValue === 'boolean' ? (newValue && 'Да') || 'Нет' : (typeof newValue === 'string' && newValue) || '',
  };
};
